import React from "react";
import VideoPlayer from "../CloudVideo/CloudVideo";
import { Link } from "react-router-dom";

const ServiceSection2 = (props) => {
  return (
    <section
      className={`wpo-department-section section-padding section-help ${props.dClass}`}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="wpo-section-title">
              <span>Como a Neurodesenvolver pode te ajudar?</span>
              <h2>Como o Kit Neurodesenvolver pode te ajudar?</h2>
              <p class="sub-text">
                A ferramenta completa para pais e terapeutas que buscam apoiar a
                jornada de aprendizado com materiais eficazes. Descubra mais de
                500 atividades lúdicas para estimular o desenvolvimento infantil
                de forma prática e divertida.
              </p>
            </div>
          </div>
        </div>
        <div className="department-wrap">
          <div className="department-doctor-wrap">
            <div className="row">
                <VideoPlayer publicId="VV-16X9_ylnsnz" />
            </div>
            <div className="col-xl-12 col-lg-12 col-12 text-center video-button">
              <Link onClick={props.link} className="theme-btn ">
                QUERO MEU KIT COMPLETO
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection2;
